export default {
	validateEmailResult : null,
    validateEmailError : null,
}